/* tslint:disable */
/* eslint-disable */
/**
 * Syte Products API
 * API services for CRA, Files, and Collaborators
 *
 * The version of the OpenAPI document: v0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the TopLevelControlChartDto interface.
 */
export function instanceOfTopLevelControlChartDto(value) {
    let isInstance = true;
    return isInstance;
}
export function TopLevelControlChartDtoFromJSON(json) {
    return TopLevelControlChartDtoFromJSONTyped(json, false);
}
export function TopLevelControlChartDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'identifier': !exists(json, 'identifier') ? undefined : json['identifier'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'ordinal': !exists(json, 'ordinal') ? undefined : json['ordinal'],
        'score': !exists(json, 'score') ? undefined : json['score'],
        'maxScore': !exists(json, 'maxScore') ? undefined : json['maxScore'],
        'elementsTotal': !exists(json, 'elementsTotal') ? undefined : json['elementsTotal'],
        'elementsCompleted': !exists(json, 'elementsCompleted') ? undefined : json['elementsCompleted'],
    };
}
export function TopLevelControlChartDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'identifier': value.identifier,
        'name': value.name,
        'ordinal': value.ordinal,
        'score': value.score,
        'maxScore': value.maxScore,
        'elementsTotal': value.elementsTotal,
        'elementsCompleted': value.elementsCompleted,
    };
}
